import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';
import { login } from './loginApi';
import { message } from "antd";

const msgKey = 'login';

export interface CounterState {
  status: 'idle' | 'loading' | 'failed' | 'success';
}

const initialState: CounterState = {
  status: 'idle',
};

export const loginAsync = createAsyncThunk(
  'login/userLogin',
  async (body: any) => {
    return await login(body);
  }
);

export const counterSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.status = 'loading';
          message.open({
              key: msgKey,
              type: 'loading',
              content: 'Authenticating...',
          })
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        state.status = 'success';
        // state.value += action.payload;
      })
      .addCase(loginAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { } = counterSlice.actions;

export const selectStatus = (state: RootState) => state.login.status;

export default counterSlice.reducer;
